// 人员用户信息管理
import { getInfo, logOut } from 'api/module/index'
import { loginIn, loginByPhone, oauthLogin } from 'api/module/index'
import { getItem, setItem, removeItem } from '@/utility/auth'
import Vue from 'vue'

import store from '../index'

const state = {
	token: getItem('token'),
	roles: [],
	userInfo: {}
}

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_ROLES: (state, roles) => {
		state.roles = roles
	},
	SET_USER_INFO: (state, info) => {
		state.userInfo = info
	},
	editInfoNickName: (state, info) => {
		state.userInfo.nickName = info
	},
	editIsReal: (state, info) => {
		state.userInfo.isReal = info
	},
	editPhone: (state, info) => {
		state.userInfo.phone = info
	},
	editSname: (state, info) => {
		state.userInfo.sname = info
	},
	// 设置头像
	SET_USER_AVATAR: (state, path) => {
		state.userInfo.filePath = path
	}
}

const actions = {
	// user login
	loginIn({ commit }, userInfo) {
		const { username, password, requestConfig } = userInfo
		return new Promise((resolve, reject) => {
			loginIn({
				username: username.trim(), // 去除首尾空格
				password: password
			})
				.then(res => {
					// console.log(res)

					Vue.prototype.mySocket.createSocket(Vue.prototype.$websocketUrl, res.data.userInfo.id)
					// 保存 token
					commit('SET_TOKEN', res.data.token)
					setItem('token', res.data.token)

					resolve()
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	// 手机号码登录 login
	loginByPhone({ commit }, userInfo) {
		const { phone, verifyCode } = userInfo
		return new Promise((resolve, reject) => {
			loginByPhone({
				phone: phone,
				verifyCode: verifyCode
			})
				.then(res => {
					// console.log(res)

					// Vue.prototype.$socket(res.data.userInfo.id)
					Vue.prototype.mySocket.createSocket(Vue.prototype.$websocketUrl, res.data.userInfo.id)

					// 保存 token
					commit('SET_TOKEN', res.data.token)
					commit('SET_USER_INFO', res.data.userInfo)
					setItem('token', res.data.token)
          let userInfo = JSON.stringify(res.data.userInfo)
					setItem('userInfo', userInfo)
					resolve()
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	// 微信/QQ 授权后登录
	oauthLogin({ commit }, params) {
		return new Promise((resolve, reject) => {
			oauthLogin(params)
				.then(res => {
					// console.log(res)
					// Vue.prototype.mySocket.createSocket(Vue.prototype.$websocketUrl, res.data.userInfo.id)
					// 保存 token
					commit('SET_TOKEN', res.data.token)
					commit('SET_USER_INFO', res.data.userInfo)
					setItem('token', res.data.token)
          let userInfo = JSON.stringify(res.data.userInfo)
					setItem('userInfo', userInfo)
					resolve(res.data)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	// 获取用户信息
	getUserInfo({ commit, state }, info) {
		return new Promise((resolve, reject) => {
			getInfo({ token: state.token })
				.then(res => {
					const { data } = res
					setItem('phone', data.phone)

					if (!data) {
						reject('验证失败，请重新登录')
					}

					commit('SET_USER_INFO', data)
					let company = data.defaultTenant || {}
					let companyName = company.sname || ''
					store.dispatch('app/setCurCompany', company)
					store.dispatch('app/setCompanyName', companyName)
					resolve(data)
				})
				.catch(err => {
					reject(err)
				})
		})
	},

	// 退出登录
	logOut({ dispatch, commit }) {
		commit('SET_TOKEN', '')
		commit('SET_ROLES', [])
		commit('SET_USER_INFO', {})
		store.dispatch('app/setCurCompany', {})
		removeItem('token')
		removeItem('phone')

		// 关闭
		// Vue.prototype.$socketClose()
		// console.log(Vue.prototype.mySocket)
		Vue.prototype.mySocket.ws.close()
		// console.log(Vue.prototype)
		// Vue.prototype.$socket()
		// return new Promise((resolve, reject) => {
		//     logOut(state.token).then(res => {
		//         commit('SET_TOKEN', '')
		//         commit('SET_ROLES', [])
		//         commit('SET_USER_INFO', {})
		//         removeItem('token')

		//         resolve()
		//     }).catch(err => {
		//         reject(err)
		//     })
		// })
	},

	// 设置头像
	setAvatarPath({ commit }, path) {
		commit('SET_USER_AVATAR', path)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js